/**
 * Utility functions and constants for Source components
 */

export const SUPPORTED_EXTENSIONS = new Set([
  '.pdf', '.docx', '.doc', '.xlsx', '.xls', '.xlsm', '.csv', '.pptx', '.ppt',
  '.jpg', '.jpeg', '.png', '.gif', '.bmp', '.tiff', '.tif',
  '.dwg', '.dxf', '.fgdb',
]);

export const EXTENSION_DESCRIPTIONS: Record<string, string> = {
  '.pdf': 'PDF Document',
  '.docx': 'Word Document',
  '.doc': 'Word Document (Legacy)',
  '.xlsx': 'Excel Spreadsheet',
  '.xls': 'Excel Spreadsheet (Legacy)',
  '.xlsm': 'Excel Macro-Enabled',
  '.csv': 'Comma-Separated Values',
  '.pptx': 'PowerPoint Presentation',
  '.ppt': 'PowerPoint (Legacy)',
  '.jpg': 'JPEG Image (OCR)',
  '.jpeg': 'JPEG Image (OCR)',
  '.png': 'PNG Image (OCR)',
  '.gif': 'GIF Image',
  '.bmp': 'Bitmap Image (OCR)',
  '.tiff': 'TIFF Image (OCR)',
  '.tif': 'TIFF Image (OCR)',
  '.dwg': 'AutoCAD Drawing',
  '.dxf': 'Drawing Exchange Format',
  '.fgdb': 'File Geodatabase',
};

export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
}

export interface FileNode {
  filename: string;
  path?: string;
  file_size_bytes: number;
  artifact_type: string;
  artifact_id?: string | null;
  created_at?: string | null;
}

export function buildFileTree(
  files: FileNode[]
): Array<{
  name: string;
  path: string;
  type: 'file' | 'folder';
  extension?: string;
  size?: number;
  artifact_type?: string;
  artifact_id?: string | null;
  created_at?: string | null;
  children?: any[];
}> {
  const tree: any[] = [];
  const pathMap: Record<string, any> = {};

  files.forEach((file) => {
    // Use path if available, otherwise use filename
    const filePath = file.path || file.filename;
    const parts = filePath.split('/').filter(p => p);
    
    let currentLevel = tree;
    let currentPath = '';

    parts.forEach((part, idx) => {
      const isFile = idx === parts.length - 1;
      currentPath = currentPath ? `${currentPath}/${part}` : part;

      if (isFile) {
        // This is the file
        const ext = part.includes('.') ? part.substring(part.lastIndexOf('.')).toLowerCase() : '';
        currentLevel.push({
          name: part,
          path: currentPath,
          type: 'file',
          extension: ext,
          size: file.file_size_bytes,
          artifact_type: file.artifact_type,
          artifact_id: file.artifact_id,
          created_at: file.created_at,
        });
      } else {
        // This is a folder
        let folderNode = pathMap[currentPath];
        if (!folderNode) {
          folderNode = {
            name: part,
            path: currentPath,
            type: 'folder',
            children: [],
          };
          currentLevel.push(folderNode);
          pathMap[currentPath] = folderNode;
        }
        currentLevel = folderNode.children;
      }
    });
  });

  return tree;
}













